import { useEffect } from "react";
import Lenis from "lenis";
import Marquee from "react-fast-marquee";
import { Toaster } from "sonner";
import "@/App.css";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Safety } from "@/components/Safety";
import { Location } from "@/components/Location";
import { ContactFaq } from "@/components/ContactFaq";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    let frame;
    const animate = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="site-shell" data-testid="gulf-coast-fleeting-landing-page">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <Safety />
        <Location />
        <ContactFaq />
      </main>
      <div className="dispatch-marquee" data-testid="dispatch-marquee">
        <Marquee speed={42} gradient={false} aria-label="Operations highlights">
          <span>24/7 REQUEST LINE</span><i />
          <span>GULF COAST PROUD</span><i />
          <span>SAFETY FIRST</span><i />
          <span>CORPUS CHRISTI, TEXAS</span><i />
        </Marquee>
      </div>
      <footer className="footer" data-testid="site-footer">
        <a className="footer-brand" href="#top" data-testid="footer-home-link">
          <img
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_page-builder-840/artifacts/j7s2mihp_004_GulfCoastFleeting_logo_white_PNG.png"
            alt="Gulf Coast Fleeting"
            data-testid="footer-company-logo"
          />
        </a>
        <p data-testid="footer-company-description">Gulf Coast Fleeting · Corpus Christi, Texas</p>
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Gulf Coast Fleeting</p>
      </footer>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;